import type { UrlOverlay } from '@/hooks/use-url-overlay';

/** The app's full-screen overlays held open by a search param; with several open, the first listed wins. */
export const urlOverlays = {
  // Only Stripe's success return opens it, never another value of the param.
  checkoutSuccess: { param: 'checkout', value: 'success', exactValue: true },
  // Only Stripe's success return opens it; its value carries the bought Joules and the amount in cents.
  rechargeSuccess: { param: 'recharged', value: '', exactValue: false },
  planPicker: { param: 'plans', value: '', exactValue: false },
  recharge: { param: 'recharge', value: '', exactValue: false },
  startPlan: { param: 'start-plan', value: '', exactValue: false },
  cancelSubscription: { param: 'cancel-subscription', value: '', exactValue: false },
  cancelPendingSubscription: { param: 'cancel-pending-subscription', value: '', exactValue: false },
} as const satisfies Record<string, UrlOverlay>;
